export const DASHBOARD = "/";
export const DEPOSIT = "/deposit";
export const MINT = "/mint";
export const SWAP = "/swap";
export const WRAP = "/wrap";
export const POOL = "/pool";
export const DOCS = "/docs";
export const PRESALE = "/presale";
export const SERIESC = "/series-c";
export const ACCOUNT = "/account";